var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Text } from 'components/Text';
import { React, useState } from 'libs/react';
import { Header } from 'components/Header';
import { Button } from 'components/Button';
import { DealActivityStreamItemsList } from './DealActivityStreamItemsList';
import { CreateDealMessageMutation } from 'graphql/Deal/mutations/CreateDealMessageMutation';
import { useMutation } from '@apollo/client';
import { DealQuery } from 'graphql/Deal/queries/DealQuery';
import { useAlert } from 'components/alert/AlertStack';
import { LazyReactQuill } from 'components/form/LazyReactQuill';
import { useDomain } from 'components/domain/DomainProvider';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import './DealActivityStream.scss';
/**
 * @component DealActivityStream
 * @since 1.0.0
 */
export function DealActivityStream(props) {
    var _a;
    const { setActivityStream, setActivityStreamSideBar, entityData, deal, entityType } = props;
    const modules = {
        toolbar: false
    };
    const formats = ['bold', 'italic', 'underline'];
    const { configurationFields } = useDomain();
    let hasChat = configurationFields
        ? getConfigurationFieldValue(configurationFields, 'CHAT_ENABLED')
        : null;
    if (deal.user &&
        [
            'ce6fb37bb3f9472d840b4a828cc7468d',
            '2050849d1fda4daa88d234718356769d',
            'a5cb986c7fbc47c2b75ccd302dc82fe0',
            'aab79aee46b9493884ef73687a1fcd88',
            '3b1931fa2b8543fb85d31f02c8e1ecce'
        ].includes((_a = deal.user) === null || _a === void 0 ? void 0 : _a.id)) {
        hasChat = 'TRUE';
    }
    else {
        hasChat = 'FALSE';
    }
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        setActivityStream(false);
        setActivityStreamSideBar && setActivityStreamSideBar(false);
    };
    const [mutate] = useMutation(CreateDealMessageMutation);
    const [value, setValue] = useState('');
    const alert = useAlert();
    const htmlRemoveRegex = /(<([^>]+)>)/gi;
    /**
     * @function submitMessage
     * @since 1.0.0
     * @hidden
     */
    const submitMessage = () => __awaiter(this, void 0, void 0, function* () {
        if (value.length > 0) {
            const mutationOption = {
                variables: {
                    input: {
                        dealId: deal === null || deal === void 0 ? void 0 : deal.id,
                        message: value.replace(htmlRemoveRegex, '')
                    }
                },
                refetchQueries: [
                    {
                        query: DealQuery,
                        variables: { input: { id: deal === null || deal === void 0 ? void 0 : deal.id } }
                    }
                ],
                update(cache) {
                    cache.evict({ fieldName: 'deal' });
                }
            };
            try {
                yield mutate(mutationOption);
            }
            catch (error) {
                alert.present({ error });
            }
            setValue('');
        }
    });
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    const onChange = (val) => {
        setValue(val);
    };
    const arrayData = entityType === 'CHAT' ? deal === null || deal === void 0 ? void 0 : deal.messages : entityData === null || entityData === void 0 ? void 0 : entityData.history;
    const arrayDataSorted = arrayData
        ? [...arrayData].sort((a, b) => {
            // Extract dates and convert to Date objects for proper comparison
            const aDate = a.__typename === 'DealMessage'
                ? new Date(a.date)
                : new Date(a.createdAt);
            const bDate = b.__typename === 'DealMessage'
                ? new Date(b.date)
                : new Date(b.createdAt);
            // Handle invalid dates
            if (isNaN(aDate.getTime()) && isNaN(bDate.getTime()))
                return 0;
            if (isNaN(aDate.getTime()))
                return 1; // Put invalid dates at the end
            if (isNaN(bDate.getTime()))
                return -1;
            // Sort in chronological order (oldest first)
            return aDate.getTime() - bDate.getTime();
        })
        : [];
    return (React.createElement("div", { className: "deal-activity-stream" },
        React.createElement("div", null,
            React.createElement(Header, null,
                React.createElement(Text, { value: entityType === 'CHAT' ? t('Chat') : t('History') }),
                React.createElement(Button, { style: "picto", picto: "xmark", noPadding: true, onPress: onClose }))),
        React.createElement("div", { className: "deal-activity-stream-container" },
            React.createElement(DealActivityStreamItemsList, { data: arrayDataSorted !== null && arrayDataSorted !== void 0 ? arrayDataSorted : [], deal: deal }),
            hasChat === 'TRUE' && entityType === 'CHAT' && (React.createElement("div", { className: "deal-activity-stream-wysiwyg" },
                React.createElement(LazyReactQuill, { modules: modules, formats: formats, placeholder: t('Write your message here'), onChange: onChange, value: value }),
                React.createElement(Button, { style: "primary", label: t('Send'), onPress: submitMessage }))))));
}
